export default __webpack_public_path__ + "static/media/f-4.e05ca04c.jpg";